/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLoaderQuarter = createReactComponent("outline", "loader-quarter", "IconLoaderQuarter", [["path", { "d": "M12 6l0 -3", "key": "svg-0" }], ["path", { "d": "M6 12l-3 0", "key": "svg-1" }], ["path", { "d": "M7.75 7.75l-2.15 -2.15", "key": "svg-2" }]]);

export { IconLoaderQuarter as default };
//# sourceMappingURL=IconLoaderQuarter.mjs.map
